import { AutoRow, ResponsiveRow } from "components/Row";
import { PageWrapper } from "pages/styled";
import React from "react";
import styled from "styled-components";
import { GraphResponsiveStyledCard } from "../component";
import UniqueWalletsGraph from "./UniqueWalletsGraph";
import HoldDurationGraph from "./HoldDurationGraph";
import WhaleGraph from "./WhaleGraph";
import TopMutualCollectionTable from "./TopMutualCollectionTable";
import CrossAppUsage from "./CrossAppUsageTable";
import TopOwners from "pages/Profile/components/TopOwners";
import TopOnwersFinancialProfileTable from "./TopOwnersFinancialProfileTable";
import TopTokensHeldByUsersTable from "./TopTokensHeldByUsersTable";

import { useHoldDuration } from "data/yoots/holdDuration";

export default function OwnersSection() {
  const refGraph: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
 const refUniqueWallets: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
  const refHoldDuration: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
  const refTable: React.RefObject<HTMLElement> =
    React.useRef<HTMLElement>(null);
  
  const holdDuration = useHoldDuration();

  return (
    <Wrapper>
      <GraphResponsiveStyledCard>
        <TopOnwersFinancialProfileTable />
      </GraphResponsiveStyledCard>

      <ResponsiveRow width={"100%"} gap="26px">
        <GraphResponsiveStyledCard ref={refUniqueWallets}>
          <UniqueWalletsGraph refGraph={refUniqueWallets} />
        </GraphResponsiveStyledCard>
        <GraphResponsiveStyledCard ref={refHoldDuration}>
          <HoldDurationGraph data={holdDuration} refGraph={refHoldDuration} />
        </GraphResponsiveStyledCard>
      </ResponsiveRow>

      {/* <GraphResponsiveStyledCard>
        <WhaleGraph refGraph={refGraph} />
      </GraphResponsiveStyledCard> */}

      
      <ResponsiveRow width={"100%"} gap="26px">
        <GraphResponsiveStyledCard ref={refTable}>
          <TopMutualCollectionTable />
        </GraphResponsiveStyledCard>
        <GraphResponsiveStyledCard ref={refGraph}>
          <TopTokensHeldByUsersTable refTable={refGraph} />
        </GraphResponsiveStyledCard>
      </ResponsiveRow>

      {/* <GraphResponsiveStyledCard>
        <CrossAppUsage />
      </GraphResponsiveStyledCard> */}
    </Wrapper>
  );
}

const Wrapper = styled.div``;
